export default __webpack_public_path__ + "static/media/lightbulb-disabled.36d14aa4.svg";